import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("vw_token", r.data.token);
    localStorage.setItem("vw_returning", "1");
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    localStorage.setItem("vw_token", r.data.token);
    localStorage.setItem("vw_returning", "1");
    setUser(r.data.user);
    return r.data.user;
  };

  const otpRequest = async (identifier) => {
    const r = await api.post("/auth/otp/request", { identifier });
    return r.data;
  };

  const otpVerify = async (identifier, code, name) => {
    const r = await api.post("/auth/otp/verify", { identifier, code, name });
    localStorage.setItem("vw_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) { console.warn("[Auth] logout request failed:", err?.message || err); }
    localStorage.removeItem("vw_token");
    setUser(null);
  };

  const refresh = checkAuth;

  return (
    <AuthContext.Provider value={{ user, loading, login, register, otpRequest, otpVerify, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
